import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs/index';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
    AppointmentListService
} from '../../appointment-list/state/appointment-list.service';
import { AppointmentSettingsActions } from './appointment-settings.actions';

@Injectable()
export class AppointmentSettingsEffects {
    constructor(
        private actions$: Actions,
        private appointmentListService: AppointmentListService) {
    }

    getAppointmentSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppointmentSettingsActions.getAppointmentSettings),
            switchMap(({userId}) =>
                this.appointmentListService.getAppointmentSettings(userId)
                    .pipe(
                        map((appointment: any) =>
                            AppointmentSettingsActions
                                .getAppointmentSettingsSuccess({displayTwoway: appointment.displayTwoway,
                                                                displayBirthday: appointment.displayBirthday,
                                                                displayIncorrectDestinator: appointment.displayIncorrectDestinator,
                                                                showProviders: appointment.showProviders})
                        )
                    )
            )
        )
    );

    updateAppointmentSettings$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(AppointmentSettingsActions.saveAppointmentSettings),
            switchMap((action: any) =>
                this.appointmentListService
                    .saveAppointmentSettings(action.displayTwoway, action.displayBirthday, action.displayIncorrectDestinator, action.showProviders)
                    .pipe(
                        map((appointment: any) =>
                            AppointmentSettingsActions
                                .saveAppointmentSettingsSuccess({displayTwoway: appointment.displayTwoway,
                                                                 displayBirthday: appointment.displayBirthday,
                                                                 displayIncorrectDestinator: appointment.displayIncorrectDestinator,
                                                                 showProviders: action.showProviders})
                        ),
                        catchError(error =>
                            of(AppointmentSettingsActions.saveAppointmentSettingsFail({error}))
                        )
                    )
            )
        )
    );
}
